export default{
  getUrlKey: function(name){
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g,'%20'))||null
  },
  validateMobile:function(mobile){
    var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
    return myreg.test(mobile);
  }
}



// WEBPACK FOOTER //
// ./src/util/MyUtil/index.js